import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Usuario/filtrarUsuarios`, method: 'POST', body: values, token: token})
}
